module.exports = {
	"LANGUAGE": "Limbă",
	"HDR-obpa_fulltext_score": "Scor",
	"HDR-obpa_name": "Nume",
	"HDR-obpa_fulltext_summary": "Rezumat",
	"QUERY LIMIT REACHED": "Există mai multe rezultate decât cele afișate. Restrângeți criteriile dvs. de căutare.",
	"NO DOCUMENTS FOUND": "Nu s-au găsit documente.",
	"OPEN IN NEW WINDOW": "Deschideti intr-o noua fereastra",
	"DOWNLOAD NATIVE": "Descărcați în format nativ",
	"CLOSE": "Închide",
	"SEARCH TYPE": "Tip de căutare",
	"DOCUMENT TYPE": "Tipul documentului",
	"SEARCH TERM": "Termen de căutare",
	"SEARCH": "Căutare",
	"RESET": "Restabili",
	"DATE": "Data",
	"FROM DATE": "De la data",
	"TO DATE": "Până la data",
	"LOADING": "Se încarcă...",
	"RETRY": "Incercati din nou",
	"ERROR": "Eroare!",
	"ERROR: QUERIES": "Imposibil de recuperat lista tipurilor de căutare.",
	"ERROR: DOCTYPES": "Imposibil de recuperat lista tipurilor de căutare.",
	"ERROR: KEYWORDS": "Imposibil de recuperat lista câmpurilor de căutare.",
	"ERROR: DOCUMENTS": "Nu se poate efectua căutarea solicitată.",
	"FORM: INVALID FULLTEXT": "Câmpul trebuie să aibă cel puțin {{chars}} caractere.",
	"FORM: INVALID DATE SHORT": "Format: {{format}} .",
	"FORM: REQUIRED KEYWORD": "Câmpul este obligatoriu.",
	"FORM: INVALID NUMERIC": "Câmpul trebuie să aibă un număr de până la {{digits}} cifre.",
	"FORM: INVALID DATE": "Câmpul trebuie să urmeze formatul {{format}} .",
	"FORM: INVALID CURRENCY": "Câmpul trebuie să fie o valoare valută valabilă.",
	"FORM: INVALID FLOAT": "Câmpul trebuie să fie un număr.",
	"FORM: INVALID LENGTH": "Câmpul trebuie să aibă cel mult {{chars}} caractere.",
	"FORM: ERRORS": "Pe formular există erori.",
	"FORM: noDate": "Este necesar să se precizeze un interval de date.",
	"FORM: noKeyword": "Este necesar să se precizeze cel puțin un câmp.",
	"FORM: noDateOrKeyword": "Un interval de date SAU Trebuie specificat cel puțin un câmp.",
	"FORM: noDateAndKeyword": "Un interval de date ȘI Cel puțin un câmp trebuie să fie specificat."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/ro.json
// module id = 360
// module chunks = 0